import React from "react";

// reactstrap components
import { Container, Row } from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter.jsx";

// index page sections
import Ourbusiness from "./IndexSections/Ourbusiness.jsx";
import OurbusinessMobile from "./IndexSections/OurbusinessMobile.jsx";
import Whoweare from "./IndexSections/Whoweare.jsx";
import WhoweareMobile from "./IndexSections/WhoweareMobile.jsx";
import PageBanner from "./IndexSections/PageBanner.jsx";
import Whatwefocus from "./IndexSections/Whatwefocus.jsx"
import Pills from "./IndexSections/Pills.jsx"

const banner =
{
  "Main": {
    background: 'content/home-singapore-blue.jpg',
    title: 'TRADING AND INVESTMENT GROUP',
  },

  "Whoweare": {
    background: '',
    title: '<p><span className="title-didot-black">WHO</span><span className="title-didot-grey"> WE ARE</span></p>',
    childTitle: '	INTERNATIONAL TRADING, ENGINEERING &<br>INVESTMENT COMPANY',
    summary: `HM Global Holdings (HMG) is a diversified global trading, engineering, and investment group connecting strategic supply chains, advanced infrastructure, and high-growth markets through trusted partnerships, global access, and disciplined execution.`,
    content1: `HM Global Holdings Pte. Ltd. (HMG) is a premier international trading, engineering, and investment company built to connect strategic supply chains, advanced infrastructure, and high-growth global markets. Through a diversified portfolio of Strategic Business Units, HMG operates across global commodity trading, energy, EPC infrastructure, cable network solutions, selected consumer sectors, and investment.`,
    content2: `Our core strength lies in bridging upstream supply with downstream market access—enabling governments, national enterprises, EPC contractors, manufacturers, and private-sector partners to secure critical materials, technologies, and commercial opportunities across Asia and beyond. HMG plays a strategic role in supporting the supply chains behind modern infrastructure, engineering technology, AI data centers, semiconductor components, and advanced industrial development. Our sourcing and trading capabilities cover critical upstream materials and infrastructure components, including optical fiber core, ultra-high-purity Germanium Tetrachloride, liquid helium, electrical and telecom cable solutions, semiconductor-related materials, and selected defense-grade heavy industrial commodities such as tungsten carbide and antimony.`,
    content3: `Fueling this expansive ecosystem is our dedicated Investment and strategic development arm, which structures opportunities through project financing, debt financing, mezzanine capital, mergers and acquisitions, and the stewardship of heritage family office capital. These structured investment frameworks are designed to maximize institutional value and preserve generational wealth. Beyond our industrial foundation, HMG also manages selected growth divisions in premium Food & Beverage distribution and entertainment management, allowing the group to maintain a diversified and resilient global platform.`,
    content4: `With anchored operational networks and affiliates across Singapore, South Korea, Vietnam, Indonesia, Japan, and the United States, HMG has built trusted relationships with government ministries, national-level enterprises, EPC contractors, global manufacturers, and private conglomerates. At HMG, we do more than participate in global trade—we structure, finance, source, and deliver the strategic platforms that power tomorrow’s infrastructure, technology, and energy economy.`
  },

  "OurBusiness": {
    background: 'content/home1.jpg',
    titleONE: 'OUR MISSION',
    contentONE: `Our mission is to operate the best general trades business from Asia-Pacific to global countries.
    We establish long lasting relationships with our clients by exceeding their expectations and
    gaining their trust through exceptional performance by every member of our team. Above all, we
    expect to surpass our clients expectations and add value to the communities we serve.`,
    titleTWO: 'OUR VISION',
    contentTWO: `Our vision is to become one of the top notch business legendries in Asia-Pacific in global
    trading and investment with strong networks combined with leanness, efficiency and agility of
    business capabilities. We want to continue our legacy as the most honest and ethical trade
    partner of choice and to be known as the premier trade partner that fosters an environment
    encouraging new ideas, new innovations and sustainable growth. We will earn our clients' trust
    and loyalty through continuous improvement driven by our core values.`
  },

  "Whatwefocus": [
    {
      titleONE: 'INTEGRITY',
      contentONE: `We venerate honesty and never compromise the truth. We will always do what is right and our
      business is based on trust. We adhere to the highest ethical standards and pledge to be
      transparent, just and consistent in word and deed.`,
      titleTWO: 'GRATITUDE',
      contentTWO: `We are truly thankful for the opportunities we have been given and believe this is the key to true greatness.
      Our positive minded team embraces gratitude as what gets poured into the glass to
      make it half full. Where there is gratitude, there is courtesy; there is a concern for the happiness
      and well-being of others.`,
    },
    {
      titleONE: 'EXCELLENCE',
      contentONE: `Our primary asset is people. We are a unified team working together to meet common goals.
      Our team is supportive of each other's efforts, loyal to one another and cares for each other
      both personally and professionally.`,
      titleTWO: 'TEAMWORK',
      contentTWO: `Our primary asset is people. We are a unified team working together to meet common goals.
      Our team is supportive of each other's efforts, loyal to one another and cares for each other
      both personally and professionally.`,
    },
    {
      titleONE: 'PASSION',
      contentONE: `We show pride, enthusiasm and dedication in everything we do. We are committed to delivering
      superior value to our clients.`
    }
  ],
  "ContactUS": {
    background: 'content/home2.png',
  },
};

class Index extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar mainScreen={true} />
        <main className="index" ref="main">
          <PageBanner banner={banner["Main"]} />
          <section>
            <Container>
              <Whoweare content={banner["Whoweare"]} />
            </Container>
            <Whatwefocus content={banner["Whatwefocus"]} />
          </section>
        </main>
        <CardsFooter />
      </>
    );
    // }
  }
}

export default Index;
